import { closePageLinkGraph } from "./pageLinkGraph.ts";

export interface PageLinksDrawerOptions {
  beforeOpen?: () => void;
}

let activeTrigger: HTMLButtonElement | null = null;

function drawer(): HTMLDialogElement | null {
  return document.querySelector<HTMLDialogElement>("dialog[data-page-links-drawer]");
}

export function closePageLinksDrawer(returnFocus = true) {
  closePageLinkGraph();
  const linksDrawer = drawer();
  if (!linksDrawer?.open) return;

  linksDrawer.close();
  if (returnFocus && activeTrigger?.isConnected) {
    activeTrigger.focus({ preventScroll: true });
  }
  activeTrigger = null;
}

export function initializePageLinksDrawer(options: PageLinksDrawerOptions = {}) {
  const linksDrawer = drawer();
  if (!linksDrawer) return;

  document.addEventListener("click", event => {
    const target = event.target as Element | null;
    const trigger = target?.closest<HTMLButtonElement>("[data-open-page-links]");
    if (!trigger) return;

    if (linksDrawer.open) {
      closePageLinksDrawer();
      return;
    }

    options.beforeOpen?.();
    activeTrigger = trigger;
    trigger.setAttribute("aria-expanded", "true");
    linksDrawer.show();
    linksDrawer.querySelector<HTMLElement>("a, button")?.focus({ preventScroll: true });
  });

  linksDrawer.addEventListener("close", () => {
    document.querySelectorAll<HTMLElement>("[data-open-page-links]")
      .forEach(trigger => trigger.setAttribute("aria-expanded", "false"));
  });

  linksDrawer.addEventListener("click", event => {
    const target = event.target as Element | null;
    if (target === linksDrawer || target?.closest("[data-close-page-links]")) {
      closePageLinksDrawer();
    }
  });

  document.addEventListener("keydown", event => {
    const graphGalleryOpen = document.querySelector<HTMLDialogElement>(
      "dialog[data-page-link-graph-gallery][open]") !== null;
    if (event.key === "Escape" && linksDrawer.open && !graphGalleryOpen) {
      event.preventDefault();
      closePageLinksDrawer();
    }
  });
}
